/** @format */

import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import Tooltip from "../../Components/Common/Tooltip";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { posVersionService } from "../../Services/posVersion.services";
import ActionModal from "../Common/ActionModal";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import AddPosVersion from "./AddPosVersion";
import UpdatePosVersion from "./UpdatePosVersion";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  const isActionAllowed = [master, admin, support].includes(parseInt(roleId));

  const { SearchBar } = Search;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [update, setUpdate] = useState(new Date());

  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
    btnClass: "",
  });

  const [actionModal, setActionModal] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtn: "",
  });

  useEffect(() => updateLocName("pos-versions"), []);
  useEffect(() => {
    setIsLoading(true);
    posVersionService
      .getAll()
      .then((res) => {
        console.log("xx", res.data);
        setData(res.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update]);

  const onClickDelete = (rowId) => {
    setActionModal({
      show: true,
      title: "PosVersion-Delete-Title",
      text: "PosVersion-Delete-Text",
      confirmBtn: "PosVersion-Delete-Btn",
      confirmAction: () => confirmDelete(rowId),
    });
  };

  function checkFormatter(cell) {
    return cell ? "Da" : "";
  }
  function actionFormatter(rowId, row) {
    return row.isCurrent ? (
      <div></div>
    ) : (
      <div
        className="action"
        onClick={(e) => {
          e.stopPropagation();
          onClickDelete(rowId);
        }}
      >
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const columns = [
    {
      dataField: "posVersionId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      hidden: !isActionAllowed,
      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "name",
      text: translator("Administration-PosVersion-Name"),
    },
    {
      dataField: "isCurrent",
      text: translator("Administration-PosVersion-IsCurrent"),
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "left" };
      },
      formatter: checkFormatter,
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (updateData == row) {
        setUpdateData(null);
      } else {
        setUpdateData(row);
      }
    },
  };

  const confirmDelete = (id) => {
    posVersionService
      .remove(id)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        setResultModal({
          ...resultModal,
          title: translator("PosVersion-ResultModal-DeleteSuccess-Title"),
          text: translator("PosVersion-ResultModal-DeleteSuccess-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("PosVersion-ResultModal-DeleteSuccess-Title"),
          text: translator("PosVersion-ResultModal-DeleteUnSuccess-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("PosVersion-View-Subtitle")}</span>
        </div>
        <div className="card-body ">
          <ToolkitProvider
            keyField="posVersionId"
            data={data}
            columns={columns}
            search
          >
            {(props) => (
              <>
                <div className="row">
                  <div className="col-md-6 col-sm-12 mt-2">
                    {isLoading ? (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between align-items-end">
                          <div>
                            <div>
                              <label>{translator("PayOption-View-Name")}</label>
                              <Tooltip
                                text={translator("PayOptionTooltip-Msg")}
                              />
                            </div>
                            <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                        <BootstrapTable
                          {...props.baseProps}
                          rowClasses="boostrap-table-row"
                          rowEvents={rowEvents}
                          noDataIndication={translator("No-Data")}
                          pagination={paginationFactory({})}

                          // onTableChange={onTableChange}
                        />
                      </>
                    )}
                  </div>

                  <div className="col-md-6 col-sm-12 mt-2">
                    {!updateData && (
                      <AddPosVersion
                        onSuccess={() => {
                          setUpdate(new Date());
                          setUpdateData(null);
                        }}
                        disabled={!isActionAllowed}
                        setResultModal={setResultModal}
                      />
                    )}
                    {updateData && (
                      <UpdatePosVersion
                        updateData={updateData}
                        disabled={!isActionAllowed}
                        onSuccess={() => {
                          setUpdate(new Date());
                          setUpdateData(null);
                        }}
                        setResultModal={setResultModal}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </ToolkitProvider>
        </div>
      </div>

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={() => {
          setResultModal({ ...resultModal, show: false });
          setUpdateData(null);
        }}
      />

      <ActionModal
        show={actionModal.show}
        handleHide={() => {
          setActionModal({ ...actionModal, show: false });
        }}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
    </div>
  );
};

export default Index;
